(() => {
  const CLIENT_KEY = 'tl_analytics_client_id';
  const SESSION_KEY = 'tl_analytics_session';
  const SESSION_TIMEOUT = 30 * 60 * 1000;

  function createId() {
    if (window.crypto?.randomUUID) {
      return window.crypto.randomUUID();
    }

    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }

  function getClientId() {
    let clientId =
      localStorage.getItem(CLIENT_KEY);

    if (!clientId) {
      clientId = createId();

      localStorage.setItem(
        CLIENT_KEY,
        clientId
      );
    }

    return clientId;
  }

  function getSessionId() {
    const now = Date.now();

    let session = null;

    const stored =
      localStorage.getItem(
        SESSION_KEY
      );

    if (stored) {
      try {
        session =
          JSON.parse(stored);
      } catch (_) {
        session = null;
      }
    }

    const expired =
      !session ||
      !session.id ||
      !session.last_activity ||
      now - session.last_activity >
        SESSION_TIMEOUT;

    if (expired) {
      session = {
        id: createId(),
        last_activity: now
      };
    } else {
      session.last_activity = now;
    }

    localStorage.setItem(
      SESSION_KEY,
      JSON.stringify(session)
    );

    return session.id;
  }

  function getContext() {
    return {
      tl_client_id:
        getClientId(),

      session_id:
        getSessionId()
    };
  }

  window.TLAnalyticsIdentity = {
    getClientId,
    getSessionId,
    getContext
  };
})();